import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { DisparoService } from '../disparo.service';
import { LoadingModalComponent } from '../../../../loading-modal/loading-modal.component';
import { AlertComponent } from '../../../../alert/alert.component';
import moment from 'moment';
import { map, Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-fire-queue',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    PickerComponent,
    ReactiveFormsModule,
    LoadingModalComponent,
    AlertComponent,
    FormsModule,
  ],
  templateUrl: './fire-queue.component.html',
  styleUrls: ['./fire-queue.component.scss'],
  providers: [DisparoService],
})
export class FireQueueComponent implements OnInit {
  //Variavel de saida para fechar o modal
  @Output() closeModal: EventEmitter<number> = new EventEmitter<number>();

  //Variaveis de loading e alerta
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;

  //Variaveis de reatividade do formulario
  public stepForm: number = 1;
  public isEmojiPickerVisible: boolean = false;

  private unsubscribe$: Subject<void> = new Subject();

  mediaFiles: File[] = [];
  mediaMeta: Array<{
    name: string;
    size: number;
    mimeType: string;
    width?: number;
    height?: number;
    duration?: number;
  }> = [];
  //Variaveis do formulario
  public countrys: Array<any> = [
    { name: 'BRA', code: '55' }, // Brasil
    { name: 'USA', code: '1' }, // Estados Unidos
    { name: 'CAN', code: '1' }, // Canadá
    { name: 'ARG', code: '54' }, // Argentina
    { name: 'MEX', code: '52' }, // México
    { name: 'GBR', code: '44' }, // Reino Unido
    { name: 'FRA', code: '33' }, // França
    { name: 'GER', code: '49' }, // Alemanha
    { name: 'ITA', code: '39' }, // Itália
    { name: 'ESP', code: '34' }, // Espanha
    { name: 'CHN', code: '86' }, // China
    { name: 'JPN', code: '81' }, // Japão
    { name: 'IND', code: '91' }, // Índia
    { name: 'AUS', code: '61' }, // Austrália
    { name: 'ZAF', code: '27' }, // África do Sul
    { name: 'RUS', code: '7' }, // Rússia
    { name: 'KOR', code: '82' }, // Coreia do Sul
    { name: 'SAU', code: '966' }, // Arábia Saudita
    { name: 'TUR', code: '90' }, // Turquia
    { name: 'SWE', code: '46' }, // Suécia
  ];
  public formQueueWAMD!: FormGroup;
  public listContacts: Array<any> = [];
  public listMessagesPredefined: Array<any> = [];
  public listChannels: Array<any> = [];
  public quantidadeMidias: number = 0;
  public errorMessage: string | null = null;
  public isScheduled: boolean = false;
  public formattedDate!: string;
  public addExt: boolean = false;
  public acceptTerm: boolean = false;

  constructor(private fb: FormBuilder, private disparoService: DisparoService) {
    this.formQueueWAMD = this.fb.group({
      nome: ['', [Validators.required]],
      idLista: ['', [Validators.required]],
      tipodisparo: ['NORMAL', Validators.required],
      mensagem: ['', [Validators.required]],
      ordemenvio: ['0', [Validators.required]],
      midias: this.fb.array([]),
      canais: this.fb.array([]),
      data: moment().format('YYYY-MM-DD HH:mm:ss'),
      saturday: [0, [Validators.required]],
      sunday: [0, [Validators.required]],
      tipobotao: ['0', [Validators.required]],
      botoes: ['', [Validators.required]],
      hComercial: [false, [Validators.required]],
      antiSpam: ['', [Validators.required]],
      typeExt: ['normal', [Validators.required]],
      extData: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    this.getListas();
    this.getMessages();
    this.getChannels();
  }

  //Funcoes de buscas de dados
  public getListas(): void {
    this.disparoService.getListas().subscribe((response: any) => {
      this.listContacts = response;
      this.formQueueWAMD.patchValue({
        idLista: `${this.listContacts[0].idlist}`,
      });
    });
  }

  public getMessages(): void {
    this.disparoService.getMessagesPreDefined().subscribe((response: any) => {
      this.listMessagesPredefined = response.messages;
    });
  }

  public getChannels(): void {
    this.disparoService
      .getCanaisNormal()
      .pipe(
        map((channels: any) =>
          channels.filter((channels: any) => channels.status === 'Conectado')
        )
      )
      .subscribe((response: any) => {
        this.listChannels = response;
      });
  }

  //Funcao para fechar o modal
  public handleCloseModal() {
    this.closeModal.emit(1);
  }

  //Funcao para fechar o modal e o modal de configuracoes
  public handleCloseAllModal() {
    this.closeModal.emit(2);
  }

  //Funcao para adicionar inputs de midias
  handleAddInputMidias() {
    if (this.quantidadeMidias < 3) {
      this.quantidadeMidias++;
    } else {
      this.alertComponent.showAlert(
        'Voce nao pode adicionar mais de 3 midias',
        'warning'
      );
    }
  }

  //funcao para remover inputs
  public handleRemoveInputMidias() {
    if (this.quantidadeMidias > 0) {
      this.quantidadeMidias--;
      this.formQueueWAMD.value.midias.pop();
    }
  }

  public handleInsertFile(event: Event) {
     const list = (event.target as HTMLInputElement).files;
    if (!list || list.length === 0) return;

    const allowed = new Set([
      'application/pdf',
      'image/jpeg',
      'image/png',
      'audio/ogg',
      'video/mp4',
    ]);

    Array.from(list).forEach((file) => {
      if (!allowed.has(file.type)) {
        this.errorMessage = `Tipo não suportado: ${file.name} (${file.type})`;
        return;
      }

      this.errorMessage = '';
      this.mediaFiles.push(file);

      // cria registro de metadados
      const meta = {
        name: file.name,
        size: file.size,
        mimeType: file.type,
        width: undefined as number | undefined,
        height: undefined as number | undefined,
        duration: undefined as number | undefined,
      };
      this.mediaMeta.push(meta);

      // coletar dimensões/duração
      const url = URL.createObjectURL(file);

      if (file.type.startsWith('image/')) {
        const img = new Image();
        img.onload = () => {
          meta.width = img.width;
          meta.height = img.height;
          URL.revokeObjectURL(url);
        };
        img.src = url;
      }

      if (file.type.startsWith('video/')) {
        const video = document.createElement('video');
        video.onloadedmetadata = () => {
          meta.width = video.videoWidth;
          meta.height = video.videoHeight;
          meta.duration = Math.ceil(video.duration);
          URL.revokeObjectURL(url);
        };
        video.src = url;
      }

      if (file.type.startsWith('audio/')) {
        const audio = document.createElement('audio');
        audio.onloadedmetadata = () => {
          meta.duration = Math.ceil(audio.duration);
          URL.revokeObjectURL(url);
        };
        audio.src = url;
      }
    });
  }

  public removeMimeType(base64String: string): string {
    // Localiza a posição do delimitador `,` e retorna o conteúdo após ele
    return base64String.substring(base64String.indexOf(',') + 1);
  }

  //Funcoes para manipulacao do ext data
  public handleAddExt(event: Event): void {
    const eventAddExt = event?.target as HTMLInputElement;

    if (eventAddExt.checked === true) this.addExt = true;

    if (eventAddExt.checked === false) {
      this.formQueueWAMD.value.extData = '';
      this.addExt = false;
    }
  }

  //Funcoes para avancar e retornar no formulario
  public handleNextStep() {
    if (this.stepForm < 4) this.stepForm++;
    console.log(this.formQueueWAMD.value);
  }

  public handlePreviousStep() {
    if (this.stepForm > 1) this.stepForm--;
  }

  /**
   * Funcoes de validacoes de etapas
   */

  //Validar step 1
  public handleValidStepOne(): boolean {
    if (!this.formQueueWAMD.value.nome || !this.formQueueWAMD.value.idLista)
      return false;

    return true;
  }

  //Validar step 2
  public handleValidStepTwo(): boolean {
    if (this.formQueueWAMD.get('mensagem')?.value.length <= 0) return false;

    return true;
  }

  //Validar step 3
  public handleValidStepThree(): boolean {
    if (this.formQueueWAMD.get('canais')?.value.length < 1) return false;

    return true;
  }

  //Validar step 4
  public handleValidStepFour(): boolean {
    if (this.acceptTerm === false) return false;

    return true;
  }

  //Funcoes de adicionar emoji
  // Fecha o seletor ao clicar fora
  @HostListener('document:click', ['$event'])
  closeEmojiPicker(event: MouseEvent) {
    this.isEmojiPickerVisible = false;
  }

  public toggleEmojiPicker(event: Event) {
    event.stopPropagation();
    this.isEmojiPickerVisible = !this.isEmojiPickerVisible;
  }

  public addEmoji(event: any) {
    const emoji = event.emoji?.native;
    if (emoji) {
      this.formQueueWAMD.patchValue({
        mensagem: this.formQueueWAMD.value.mensagem + emoji,
      });
    }
  }

  //Funcao para manipular a mensagem predefinida
  handleSelectMessagePredefined(event: Event) {
    const message = event?.target as HTMLInputElement;
    if (message) {
      this.formQueueWAMD.patchValue({
        mensagem: message.value,
      });
    }
  }

  handleAddRefName() {
    this.formQueueWAMD.patchValue({
      mensagem: this.formQueueWAMD.value.mensagem + '[NOME]',
    });
  }

  /**
   * Funcoes para selecionar canais
   */

  public handleSelectChannel(event: Event) {
    const channelValue: any = event?.target as HTMLInputElement;

    if (channelValue.checked === true) {
      if (channelValue.value) {
        this.formQueueWAMD.value.canais.push(channelValue.value);
      }
    }

    if (channelValue.checked === false) {
      if (channelValue.value) {
        this.formQueueWAMD.value.canais.splice(
          this.formQueueWAMD.value.canais.indexOf(channelValue.value),
          1
        );
      }
    }

    console.log(this.formQueueWAMD.value.canais);
  }

  //Funcoes de personalizacao do disparo
  public handleIsScheduled(event: Event): void {
    const data: any = (event?.target as HTMLInputElement).checked;

    if (data === true) {
      this.isScheduled = true;
      this.formQueueWAMD.get('tipodisparo')?.setValue('AGENDADO');
      return;
    }

    this.formQueueWAMD.patchValue({
      data: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.isScheduled = false;
    this.formQueueWAMD.get('tipodisparo')?.setValue('NORMAL');
  }

  public handleManualyTimeData(event: Event): void {
    const hourNow: string = (event?.target as HTMLInputElement)?.value;

    const segmentHours: any = hourNow.split(' ');

    const [hour, minutes] = hourNow.split(':');

    console.log('Horas: ', hour);
    console.log('Minutes: ', minutes);

    this.formQueueWAMD.patchValue({
      data: moment(this.formQueueWAMD.get('data')?.value, 'YYYY-MM-DD HH:mm:ss')
        .hour(parseInt(hour))
        .minute(parseInt(minutes))
        .seconds(0)
        .format('YYYY-MM-DD HH:mm:ss'),
    });

    console.log('Nova Data: ', this.formQueueWAMD.get('data')?.value);
  }

  public handleManualyDateData(event: Event): void {
    const dateSelected: string = (event?.target as HTMLInputElement)?.value;

    this.formattedDate = dateSelected;
    const [year, month, day] = dateSelected.split('-');

    console.log(`Ano ${year}, Mes: ${month}, Dia: ${day}`);

    this.formQueueWAMD.patchValue({
      data: moment(this.formQueueWAMD.get('data')?.value, 'YYYY-MM-DD HH:mm:ss')
        .date(parseInt(day))
        .month(parseInt(month) - 1)
        .year(parseInt(year))
        .format('YYYY-MM-DD HH:mm:ss'),
    });
  }

  public handleAcceptTerm(event: Event) {
    const eventCheckbox: any = event?.target as HTMLInputElement;

    if (eventCheckbox.checked === true) {
      this.acceptTerm = true;
    }

    if (eventCheckbox.checked === false) {
      this.acceptTerm = false;
    }
  }

  public handleSendFire() {
  // Inicia o loading
  this.loadingComponent.activeLoading();

  const v = this.formQueueWAMD.value;

  // === 1) Monta o objeto "dados" exatamente como o backend espera ===
  const dados = {
    nome: String(v.nome),
    idLista: String(v.idLista),
    tipodisparo: String(v.tipodisparo ?? 'NORMAL'),

    mensagem: String(v.mensagem),
    ordemenvio: String(v.ordemenvio ?? '0'),

    data: String(v.data ?? moment().format('YYYY-MM-DD HH:mm:ss')),

    saturday: Number(v.saturday ?? 0),
    sunday: Number(v.sunday ?? 0),

    tipobotao: String(v.tipobotao ?? '0'),
    botoes: String(v.botoes ?? '[]'),

    hComercial: v.hComercial ? 1 : 0,
    antiSpam: v.antiSpam ? 1 : 0,

    typeExt: String(v.typeExt ?? 'normal'),
    extData: String(v.extData ?? ''),

    canais: (v.canais ?? []).map(String),
  };

  // === 2) Constrói o FormData ===
  const fd = new FormData();

  // Adiciona os dados principais em JSON
  fd.append('dados', JSON.stringify(dados));

  // Adiciona as mídias (caso tenha alguma selecionada)
  // Aqui assumimos que você armazenou os arquivos em `this.mediaFiles`
  // ou dentro do form em `this.formQueueWAMD.value.midias`
  const midias = this.mediaFiles ?? v.midias ?? [];

  if (midias.length) {
    midias.forEach((f: File) => fd.append('midias', f));
  }

  // === 3) Envia com o service ===
  this.disparoService
    .setDisparoNormalLista(fd) // agora recebe FormData
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe({
      next: () => {
        this.handleCloseAllModal();
        this.loadingComponent.inactiveLoading();
        this.alertComponent.showAlert('Disparo criado com sucesso', 'success');
      },
      error: (error) => {
        console.error(error);
        this.handleCloseAllModal();
        this.loadingComponent.inactiveLoading();
        this.alertComponent.showAlert(
          `Erro ao criar disparo: ${error?.error?.error?.message ?? ''}`,
          'error'
        );
      },
    });
}

}
